import { useCallback } from 'react';

import Button from '@gogame/ui/Button';
import { AddIcon } from '@gogame/ui/Icon';
import { Picker } from '@gogame/ui/Picker';

const defaultGetOptionValue = ({ id }) => id;

const MetricMenu = ({
  metrics,
  disabled,
  loading,
  className,
  onChange,
  label,
  groupBy,
  getOptionValue = defaultGetOptionValue,
  renderOption,
}) => {
  const handleChange = useCallback(
    ([opt]) => {
      onChange({}, getOptionValue(opt));
    },
    [onChange]
  );
  return (
    <Picker
      button={
        <Button
          color={'primary'}
          startIcon={<AddIcon />}
          className={className}
          disabled={disabled}
        >
          {label}
        </Button>
      }
      onChange={handleChange}
      renderOption={renderOption}
      options={metrics}
      disabled={disabled}
      loading={loading}
      groupBy={groupBy}
    />
  );
};
export default MetricMenu;
